import { wrapCreateBrowserRouterV7 } from "@sentry/react";
import { createBrowserRouter } from "react-router";

import { ErrorPage } from "@pages/error/page";
import { getRoleRoutes } from "@routes/getRoleRoutes.ts";
import { layoutRoutes } from "@routes/layoutRoutes.ts";
import { outsideRoutes } from "@routes/outsideRoutes.ts";

import { protectedLoader } from "./authLoaders";

import type { IRoleEnum } from "@interfaces";

const sentryCreateBrowserRouter =
  wrapCreateBrowserRouterV7(createBrowserRouter);

export const getRouter = (role: IRoleEnum | null) => {
  return sentryCreateBrowserRouter([
    {
      path: "/",
      lazy: () => import("@pages/rootPage/page"),
      children: [
        ...outsideRoutes,
        {
          lazy: () => import("@pages/layout/page"),
          children: getRoleRoutes(role, layoutRoutes),
          loader: protectedLoader,
        },
      ],
      errorElement: <ErrorPage />,
    },
  ]);
};
